import {WINDOW_RESIZE, WINDOW_SCROLL} from '../actions/viewport';

const getViewport = () => {
        const {innerWidth, innerHeight, pageXOffset, pageYOffset} = window, {
                clientWidth,
                clientHeight,
                clientLeft,
                clientTop,
                scrollLeft,
                scrollTop
            } = document.documentElement,
            width = Math.max(clientWidth, innerWidth || 0),
            height = Math.max(clientHeight, innerHeight || 0),
            left = (pageXOffset || scrollLeft) - (clientLeft || 0),
            top = (pageYOffset || scrollTop) - (clientTop || 0);
        return {
            width,
            height,
            left,
            top,
            right: left + width,
            bottom: top + height,
            x: left + width / 2,
            y: top + height / 2,
            aspect: width / height
        };
    },
    initialState = getViewport();

export default(state = initialState, action) => {
    switch (action.type) {
        case WINDOW_RESIZE:
        case WINDOW_SCROLL:
            return getViewport();
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/viewport.js